<template>
  <div class="container_map">
    <div>
      <b-alert
        variant="danger"
        dismissible
        fade
        :show="showBasketAlert"
        @dismissed="showBasketAlert=false"
      >
        <p class="basket-alert-text">{{ $t('map.max_select_message') }}</p>
        <b-button class="basket-alert-btn" @click="clearBasket()" variant="info">{{ $t('map.new_selection') }}</b-button>
      </b-alert>
    </div>

    <div v-show="selectedInTheSelector !== 'pins' && mapConfig.page !== 'borden'" id="map_filter_div" :class="{ main_map_filter_div: mapConfig.page !== 'borden' }">
      <p>{{ $t('datetime.last') }}: </p>
      <div id="map_filter_btn_group" class="btn-group">
        <button class="btn" :class="{active: timeFilter=='lastMonth'}" id="lastMonth" @click="toggleTimeFilter('lastMonth');">{{ $t('datetime.month') }}</button>
        <button class="btn" :class="{active: timeFilter=='lastWeek'}" id="lastWeek" @click="toggleTimeFilter('lastWeek');">{{ $t('datetime.week') }}</button>
        <button class="btn" :class="{active: timeFilter=='lastDay'}" id="lastDay" @click="toggleTimeFilter('lastDay');">{{ $t('datetime.day') }}</button>
      </div>
    </div>

    <transition name="router-animation" enter-active-class="animated slideInDown" leave-active-class="animated slideOutDown" mode="out-in">
    <modal name="controllerModalSelector" class="controllerModalSelector" height="auto" :adaptive="true" :clickToClose="true" @before-close="patchMapConfig">
        <div class="float-right">
          <button class="btn-close btn btn-sm" @click="$modal.hide('controllerModalSelector')">
            <img class="btn-cross" src="../../assets/images/cross_blue.png"/>
          </button>
        </div>
        <p class="selector-checkunit">{{ checkUnit }}</p>
        <h4 class="selector-title">{{ $t('map.map_layers') }}</h4>
        <b-form-group>

        <div class="row-buttons" v-if="config.layer_config.overlay_layers" >
          <b-form-checkbox-group class="button-map ml-2 mt-2" size="sm" button-variant="sm" buttons v-for="layer in config.layer_config.overlay_layers" name="checkboxComponentLayers" :key="layer.id" v-model="selectedInTheSelectorOverlaylayers">
              <b-form-checkbox :value="layer.id" @change="onLayersChange(layer.id, layer.visible, config.layer_config.overlay_layers)">
                <img class="mb-1" :src="layer.src" alt=""/>
                <p>{{ layer.name }}</p>
              </b-form-checkbox>
          </b-form-checkbox-group>

            <!-- Timedimension forecast item
            <b-form-checkbox-group class="button-map ml-2 mt-2 timedimension-items" size="sm" button-variant="sm" buttons name="checkboxComponentLayers" v-for="(timedimension, index) in timediminesionList" :key="timedimension.name" v-model="selectedInTheSelectorTimedimension">
                <b-form-checkbox :value="timedimension.name"   v-if="isTimedimensionAvailable(timedimension.name)" @change="onTimedimensionChange($event, timedimension)" >
                    <img  class="mb-1" :src="timedimension.src" alt=""/>
                    <p  v-html=" timedimension.name"></p>
                </b-form-checkbox>
            </b-form-checkbox-group> -->

        </div>
        <div class="row-buttons" v-if="pointsControlObject">
          <b-form-radio-group class="button-round ml-2" size="sm" button-variant="sm" buttons v-for="layer in pointsControlObject" v-model="selectedInTheSelector"  @change="parameterChanged(layer)" name="radioComponentLayers" :key="layer.name">
              <b-form-radio checked="checked" :value="layer.name"  v-if="isParameterAvailable(layer.name)">
                <img class="mb-1" style="background-color: #f2efe9" :src="layer.img_src" :alt="layer.img_src"/>
                 <p>{{ layer.title_name }}</p>
              </b-form-radio>
          </b-form-radio-group>
        </div>
            <div class="row-buttons" v-if="serieCategories">
                <b-form-checkbox-group class="button-map category-filter ml-2" size="sm" button-variant="sm" buttons  v-for="category in serieCategories" v-model="selectedInTheSelectorCategories" name="radioComponentLayers" :key="category.name">
                    <b-form-checkbox :value="category.name"  v-if="isCategoryAvailable(category.name) && (selectedInTheSelector != 'WaterLevel' ||  (selectedInTheSelector == 'WaterLevel' && (category.name != 'Shallow'  && category.name != 'Deep')))">
                        <img class="mb-1" style="background-color: #f2efe9" :src="category.img_src" :alt="category.img_src"/>
                        <p>{{category.title_name}}</p>
                    </b-form-checkbox>

                    <!-- Oppervlakte water uitzondering -->
                    <b-form-checkbox value="Oppervlakte water"  class="oppervlakte_water" :class="category.name" v-if="isCategoryAvailable(category.name)  &&(selectedInTheSelector == 'WaterLevel' && (category.name == 'Shallow'  || category.name == 'Deep'))">
                        <img class="mb-1" style="background-color: #f2efe9" :src="category.img_src" :alt="category.img_src"/>
                        <p>{{ $t('map.surface_water') }}</p>
                    </b-form-checkbox>
                </b-form-checkbox-group>
            </div>
        <div class="row-buttons" v-if="config.layer_config.base_layers">
          <b-form-radio-group class="button-filter ml-2 mt-2" size="sm" button-variant="sm" buttons v-for="layer in config.layer_config.base_layers" v-model="selectedInTheSelectorBaselayer" name="checkboxComponentLayers" :key="layer.id">
              <b-form-radio :value="layer.name" @change="onLayersChange(layer.id, layer.visible, config.layer_config.base_layers)">
                <img class="mb-1" :src="layer.src" alt=""/>
                <p>{{ layer.name }}</p>
              </b-form-radio>
          </b-form-radio-group>
        </div>

        </b-form-group>
    </modal>
    </transition>

    <transition name="router-animation" enter-active-class="animated slideInDown" leave-active-class="animated slideOutDown" mode="out-in">
    <modal name="controllerModalLegends" class="controllerModalLegends" height="auto" :adaptive="true" :clickToClose="true" :pivotX="pivotX">
      <div class="float-right">
        <button class="btn-close btn btn-sm" @click="$modal.hide('controllerModalLegends')">
          <img class="btn-cross" src="../../assets/images/cross_blue.png"/>
        </button>
      </div>
      <h4 class="legenda-title">{{ $t('map.legend') }}</h4>
        <div v-if="!isSimple" class="row-buttons">
            <div class="dots-container">
                <div  class="dots-legenda row text-center m-2">
                    <div style="padding-top: 9px">
                        <p>{{ $t('map.sources') }}:</p>
                    </div>
                    <div class="col-dots" >
                        <p>{{ $t('map.pin') }}</p>
                        <span class="triangle" ></span>
                    </div>
                    <div class="col-dots" >
                        <p>{{ $t('map.mobile') }}</p>
                        <span class="dot" ></span>
                    </div>
                    <div class="col-dots" >
                        <p>{{ $t('map.external') }}</p>
                        <span class="square" ></span>
                    </div>
                </div>
            </div>
        </div>
      <div class="row-buttons">
        <div class="dots-container">
          <div v-if="currentLegend && currentLegend.choices" class="dots-legenda row text-center m-2">
            <div>
              <p style="padding-top: 11px">{{currentLegend.name}}</p>
              <p style="padding-top: 30px">{{currentLegend.secondary_name}}</p>
            </div>
            <div class="col-dots" v-for="(choice, index) in currentLegend.choices" :key="index">
              <p>{{ choice.label }}</p>
              <span class="dot" :style="{background: choice.color}"></span>
              <p>{{ choice.secondary_label }}</p>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="row-buttons">
      <b-form-group v-if="config.legend_config">
        <b-form-radio-group class="button-legenda-map ml-2" size="sm" button-variant="outline-warning sm" buttons v-model="selectedLegend" name="radioComponentLayers" v-for="(legend, index) in config.legend_config" :key="legend.name">
          <b-form-radio :value="legend.name" @change="onLegendsChange(legend)">
            <img class="mb-1" src="../../assets/images/map-1.png" alt=""/>
            <p>{{ legend.name }}</p>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      </div>-->

    </modal>
    </transition>

    <transition name="router-animation" enter-active-class="animated slideInDown" leave-active-class="animated slideOutDown" mode="out-in">
    <modal name="pinModal" height="auto" class="modalLegends" :maxWidth="pinModalWidth" :adaptive="true" @before-close="beforeClose">
      <router-link v-for="(modules, index) in selectedMapPin" :key="index" :to="{ name: 'analysis', params: {selectedTimeseries: modules} }"><fixeauModuleMap :modules='modules' :key="index"> </fixeauModuleMap></router-link>
    </modal>
    </transition>

    <transition name="router-animation" enter-active-class="animated slideInDown" leave-active-class="animated slideOutDown" mode="out-in">
    <modal name="timeseriesModal" height="auto" class="modalTimeseries" width="400px" :adaptive="true" @before-close="beforeClose">
      <div v-if="currentTimeseries" class="timeseries-modal-container">
        <h3>{{currentTimeseries.name}}</h3>
        <b-form-checkbox-group v-model="itemsBasketLocal">
          <b-form-checkbox
            id="vergelijkenCheckbox"
            name="vergelijkenCheckbox"
            :value="currentTimeseries.id"
            @change="onChangingSelectedTimeseries(currentTimeseries)"
            class="float-left mt-2">
            {{ $t('map.compare') }}
          </b-form-checkbox>
        </b-form-checkbox-group>
        <button class="btn btn-modal-timeseries float-right" @click="goToMeasurements()">{{ $t('map.measurements') }}</button>
      </div>

    </modal>
    </transition>

    <transition name="router-animation" enter-active-class="animated slideInDown" leave-active-class="animated slideOutDown" mode="out-in">
    <modal name="saveToBoardModal"  width="400px" height="auto">
      <h3>{{ $t('map.save_board') }}</h3>

      <div id="board_save_error">
        <p v-if="saveBoardErrors.length">
          <b>{{ $t('map.error') }}:</b>
          <ul>
            <li v-for="(error, index) in saveBoardErrors" :key="index">
              <p>{{ error }}</p>
            </li>
          </ul>
        </p>
      </div>

      <div>
        <p>{{ $t('map.name_board') }}:</p>
      </div>
      <div>
        <input v-model="boardName" :placeholder="$t('map.name_board_placeholder')">
      </div>
      <div>
        <button class="btn" @click="saveToBoard()">{{ $t('map.save_as_board') }}</button>
      </div>
    </modal>
    </transition>

    <transition name="router-animation" enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft" mode="out-in">
        <modal name="controllerModalChart" class="controllerModalChart" height="800px"  :width="598" :adaptive="true" :clickToClose="false" :pivotX="0.01"  @before-open="resizeChart">
            <div class="chart-modal-wrapper chart-modal-wrapper-top">
                <analysis-chart :class="{ 'active' : selectedChart && selectedChart.id == 1}" @click.native="selectChart('chart_component')" v-if="chartOneVisible" class='map-chart' id="1"  ref="chart_component"  key="chart_component" first="true" from="map" > </analysis-chart>
            </div>
            <div  v-if="(!chartTwoVisible || !chartOneVisible) &&  !(!chartTwoVisible && !chartOneVisible)" class="add-new-chart" v-bind:class="{ add_margin : (!chartOneVisible && chartTwoVisible) }">
                <img  @click="addSecondChart" src="../../assets/images/plus-icoon.png" />
            </div>
            <div class="chart-modal-wrapper">
                <analysis-chart :class="{ 'active' : selectedChart && selectedChart.id == 2}"  @click.native="selectChart('chart_component_2')"  v-if="chartTwoVisible" class='map-chart' id="2" ref="chart_component_2"  key="chart_component_2" from="map" > </analysis-chart>
            </div>
        </modal>
    </transition>
    <v-dialog enter-active-class="animated slideInTop" leave-active-class="animated slideOutDown" />


    <l-map
      ref="map"
      id="map"
      :zoom="zoom"
      :maxZoom="18"
      :center="center"
      @update:center="updateCenter"
      style="height: 100%"
      @update:zoom="updateZoom">

      <!-- Button trigger modal -->
      <button v-if="mapConfig.page !== 'borden'" id="selectors" type="button" class="btn btn-primary" v-on:click="showModalSelectors"></button>

      <button v-if="selectedInTheSelector == 'WaterLevel' && mapConfig.page !== 'borden' && !isSimple"  id="prefer_surface_level" :class="{selected: !preferSurfaceLevel}" type="button" class="btn btn-info"  v-on:click="toggleSurfaceLevel" ></button>
      <button v-if="mapConfig.page !== 'borden' && selectedInTheSelector !== 'pins' && !this.$store.state.publicAccount && !isMobile && !isSimple"  id="save_to_board_btn" type="button" class="btn btn-info"  v-on:click="showSaveToBoardModal" ></button>
      <button v-if="mapConfig.page === 'borden' && selectedInTheSelector !== 'pins'"  id="legends" type="button" class="btn btn-info" v-on:click="showModalLegends"></button>
      <button v-if="mapConfig.page !== 'borden' && selectedInTheSelector !== 'pins'"  id="legends_main_map" type="button" class="btn btn-info" v-on:click="showModalLegends"></button>

      <!----------------------------Timeseries----------------------------->
      <!--<v-marker-cluster v-if="this.parameterSeries.features && showParameterSeries" :options="clusterOptions" :ready="true" ref="clusterRef">-->
        <l-geo-json v-if="parameterSeries.features && showParameterSeries && !checkHandheldsDisplay"
          :geojson="parameterSeries"
          :options="timeseriesOptions"/>
      <!--</v-marker-cluster>-->
      <l-geo-json ref="grayTimeseriesGeojson" v-show="grayTimeseries.features && showParameterSeries && !checkHandheldsDisplay"
        :geojson="grayTimeseries"
        :options="grayTimeseriesOptions"/>
      <!-------------------------------------------------------------------->

      <v-marker-cluster v-if="checkPinsDisplay"  :animateAddingMarkers="true" :options="clusterOptions" :ready="true">
        <l-geo-json
          :geojson="pinsPoints"
          :options="pinsPointsOptions"/>
      </v-marker-cluster>


      <v-marker-cluster v-if="checkHandheldsDisplay"  :animateAddingMarkers="true" :options="clusterOptions" :ready="false">
        <l-geo-json
          :geojson="timeseries"
          :options="handheldsOptions"/>
      </v-marker-cluster>

    </l-map>
    <!--<time-dimension ref="timedimension" v-if="isMounted"  config="{}"></time-dimension>-->

  </div>
</template>

<script>
  import { LMap, LGeoJson } from 'vue2-leaflet';
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import axios from 'axios';

 // import TimeDimension from './TimeDimension'

  import 'leaflet-triangle-marker';
  import 'leaflet-svg-shape-markers';
  import './betterWMS.js';
  import 'leaflet.locatecontrol';
  //import {Compass} from './leaflet-compass/leaflet-compass.js';

  import i18n from '@/i18n';
  import scenarioMapHelper from '@/helpers/scenarioMapHelper';
  import 'vue-awesome/icons'

  import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'
  import fixeauModuleMap from './fixeauModuleMap'
  import analysisChart from '../analysis/analysisChart';
  import JQUERY from 'jquery'
  import _ from 'lodash';

  let scada = require('./scada');

  delete L.Icon.Default.prototype._getIconUrl
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
  });

  let pinIcon = function () {
    return new L.DivIcon({
        className: 'pin-div-icon',
        html: `<img class="my-div-image" src="${require('@/assets/images/pin.png')}"/>`,
        iconSize: [21, 40],
        iconAnchor: [10.5, 40],
    })
  };
  let handheldIcon = function () {
    return new L.DivIcon({
        className: 'handheld-div-icon',
        html: `<img class="my-div-image" src="${require('@/assets/images/probe.png')}"/>`,
        iconSize: [18, 36],
        iconAnchor: [9, 36],
    })
  };
  let checkmarkTimeseries = new L.DivIcon({
    className: 'checked-timeseries',
    html: `<img class="my-div-image-2" src="${require('@/assets/images/checkmark-timeseries.png')}"/>`,
    iconSize:     [18, 24], // size of the icon
    iconAnchor:   [9, 13], // point of the icon which will correspond to marker's location
  });

  // let checkmarkTimeseries1 = new L.DivIcon({
  //   className: 'checked-timeseries',
  //   html: `<p class="checked-timeseries">1</p>`,
  //   iconSize:     [18, 24], // size of the icon
  //   iconAnchor:   [9, 13], // point of the icon which will correspond to marker's location
  // });

  // let checkmarkTimeseries2 = new L.DivIcon({
  //   className: 'checked-timeseries',
  //   html: `<p class="checked-timeseries">2</p>`,
  //   iconSize:     [18, 24], // size of the icon
  //   iconAnchor:   [9, 13], // point of the icon which will correspond to marker's location
  // });
  function formatMarkerInfo (feature) {
      let html = `<table id="marker_hover_table">
                    <tr><th>${i18n.t('map.name')}: </th><td>${feature.name}</td></tr>
                    <tr><th>${i18n.t('datetime.date')}: </th><td>${new Date(feature.latest.time).toLocaleString()}</td></tr>
                    <tr><th>${i18n.t('map.value')}: </th><td>${feature.latest.value.toFixed(2)} ${feature.unit}</td></tr>
                  </table>`
      return html
  }
  function formatMarkerInfoPin (feature) {
      let html = `<table id="marker_hover_table">
                    <tr><th>${i18n.t('map.name')}: </th><td>Pin ${feature.properties.MACAddress.slice(-3)}</td></tr>
                  </table>`
      return html
  }

  const canvasRenderer = L.canvas({ padding: 0.1 })

  export default {
    props: ['mapConfig'],
    name: 'map_countainer',
    components: {
      LMap, LGeoJson, 'v-marker-cluster': Vue2LeafletMarkercluster, fixeauModuleMap, analysisChart
    },
    created() {
      this.loadZoom();
    },
    mounted() {
      let Map = this.$refs.map.mapObject;
      Map.attributionControl.setPrefix('<a href="https://leafletjs.com" title="A JavaScript library for interactive maps"> Leaflet</a>');

      //-------remove zoom control buttons from the map-------
      Map.zoomControl.remove();
      //-----------------------------------------------------
      this.markerGroupOfCheckmarks = L.layerGroup().addTo(Map)
      this.markerGroupOfCheckmarks.setZIndex(1000);

      this.$store.dispatch('retrievePinsPoints');
      this.$store.dispatch('retrieveConfig')
      .then(() => {
        this.loadZoom();
        if (!this.mapConfig.isBord) {
          //Load only from server config if its not a board.
          if ( localStorage.getItem('selectedInTheSelectorOverlaylayers') === null) {
            let visibleLayers = [];
            this.config.layer_config.overlay_layers.forEach(layer => {
              if (layer.visible) {
                visibleLayers.push(layer.id);
              }
            });
            this.selectedInTheSelectorOverlaylayers = visibleLayers;
          }
          if ( localStorage.getItem('selectedInTheSelectorBaselayer') === null) {
            this.selectedInTheSelectorBaselayer = this.$store.state.config.layer_config.base_layers.filter(layer => layer.visible == true)[0].name;
          }
          if ( localStorage.getItem('selected_categories') === null) {
            this.selectedInTheSelectorCategories = this.$store.state.config.layer_config.selected_categories;
          }
          if ( localStorage.getItem('selected_timedimension') === null) {
            this.selectedInTheSelectorTimedimension = this.$store.state.config.layer_config.selected_timedimension;
          }
          if ( localStorage.getItem('selectedInTheSelector') === null) {
            this.selectedInTheSelector = this.$store.state.config.layer_config.selected_parameter || 'pins';
          }
        }
        let vm = this;
        this.timeseriesOptions = {
          style: {
            pane:  "overlayPane"
          },
          pointToLayer: function (feature, latlng) {
            return vm.getMarker(feature.data_source, latlng, vm.getFeatureColor(feature)).bindTooltip(formatMarkerInfo(feature),{permanent:false,className:"label",opacity:0.7,direction:"top",offset:[0, -8]});
          },
          onEachFeature: this.mapConfig.markersOption.timeseriesOptions(this),
        }
      })
      .then(() => {
        this.$store.dispatch('retrieveTimeseriesPerParameter', this.selectedInTheSelector) .then(() => {
          if (this.selectedInTheSelector != 'pins') {
            this.updateTimeseriesOnMap();
          }

          this.filterTimeseries(this.selectedInTheSelector);
          this.initLayers();

          //this.preferSurfaceLevel = this.$store.state.preferSurfaceLevel;
          localStorage.setItem('legends-config', JSON.stringify(this.config.legend_config));
          if (this.selectedInTheSelector !== 'pins') {
            this.updateLegend();
          }
        }).then(() => {
          let vm = this;
          this.$store.dispatch('retrieveTimeseries', false).then(() => {
            if (vm.selectedInTheSelector === 'pins') {
              this.updateTimeseriesOnMap();
            }
          });
        });
      })
      .then(() => {
        if (this.mapConfig.page !== 'borden') {
          let OPTIONS = {
            locateOptions: {
              enableHighAccuracy: true
            },
            drawCircle: false,
            enableHighAccuracy: true,
            flyTo: true,
              strings: {
                popup: i18n.t('map.your_location'),
                title: i18n.t('map.show_me_my_location')
            }
          };
          let map = this.$refs.map.mapObject;
          L.control.locate(OPTIONS).addTo(map);
        }
      }).then(() => {
        let Map = this.$refs.map.mapObject;
        L.control.scale({position: 'bottomleft', maxWidth: '200', imperial: false}).addTo(Map);
      }).then(() => {
        //-----------------------Add Compass----------------------
        //let Map = this.$refs.map.mapObject;
        // if (this.mapConfig.page !== 'borden') {
        //   Map.addControl( new L.Control.Compass({autoActive: true, showDigit:false, position: 'topleft'}) );
        // }
      }).then(() => {
        if(this.mapConfig.page !== 'borden') {
          this.pivotX = 0.5
        } else if (this.mapConfig.page === 'pins') {
          this.pivotX = 0.29
        }
      }).then(() => {
        if (this.mapConfig.page === 'main_map_container') {
          const doNotAdd = 'DoNot add items to the bascket again';
          this.$store.state.timeseriesBasket.map(timeseries => this.onChangingSelectedTimeseries(timeseries, doNotAdd))
        }
      }).then(() => {
        this.resetTimeFilter();
        if (this.mapConfig.timeFilter) {
          this.applyTimeFilter(this.mapConfig.timeFilter);
        }
      }).then(() => {
        this.isMounted = true;
        const vm = this;
        Map.on("click", function(e) {
          scenarioMapHelper.onClick(Map, e.latlng.lat, e.latlng.lng, vm.latestLayer);
        });
      }).then(() => {
        if (this.selectedInTheSelectorTimedimension !== undefined && this.selectedInTheSelectorTimedimension.length > 0) {
          // let timedimension = this.timediminesionList.find(item => item.name == this.selectedInTheSelectorTimedimension[0]);
          // this.$refs.timedimension.showTimedimension(timedimension.config);
        }
      });
    },
    data () {
      let vm = this;
      return {
        pivotX: 0.29,
        zoom: 3,
        /* Chart pop-up */
        selectedChart: null,
        chartOneVisible: false,
        chartTwoVisible: false,
        chartOneSeries: [],
        chartTwoSeries: [],
        saveBoardErrors: [],

        timeseries:   { type: "FeatureCollection", features : [] },
        /* END Chart pop-up */
        allowToggleSurfaceLevel: true,
        center: L.latLng(25.0, 0.0),
        timeseriesOptions: null,
        grayTimeseriesOptions:{
          style: {
            pane:  "tilePane"
          },
          pointToLayer: function (feature, latlng) {
              const extraOptions = {
                  fillOpacity: 0.3,
                  opacity: 0.3,
                  fillColor: "#a9a9a9",
                  weight: 0.5,
              };
            return vm.getMarker(feature.data_source, latlng, "#a9a9a9", extraOptions).bindTooltip(formatMarkerInfo(feature),{permanent:false,className:"label",opacity:0.7,direction:"top",offset:[0, -8]});
          },
        },
        handheldsOptions:{
          pointToLayer: function (feature, latlng) {
            if (!(feature.meta && feature.meta.pin_height)) {
              return L.marker(latlng, {icon: handheldIcon(feature)}).bindTooltip(formatMarkerInfo(feature),{permanent:false,className:"label",opacity:0.7,direction:"top",offset:[0,-32]});
            }
          },
          onEachFeature: this.mapConfig.markersOption.handheldsOptions(this),
        },
          handHeldDataLoaded: false,
        pinsPointsOptions:{
          pointToLayer: function (feature, latlng) {
            return L.marker(latlng, {icon: pinIcon(feature)}).bindTooltip(formatMarkerInfoPin(feature),{permanent:false,className:"label",opacity:0.7,direction:"top",offset:[-1,-40]}).setZIndexOffset(1000);
          },
          onEachFeature: this.mapConfig.markersOption.pinsOptions(this),
        },
        clusterOptions: { disableClusteringAtZoom: 12, spiderfyOnMaxZoom: false },
        pointsControlObject: [
          {title_name: i18n.t('map.devices'), name: 'pins', img_src: 'https://dashboard.fixeau.com/selector-images/pins.png', unit: ''},
          {title_name: i18n.t('parameters.ec'), name: 'EC', img_src: 'https://dashboard.fixeau.com/selector-images/ec.png', unit: 'mS/cm' },
          {title_name: i18n.t('parameters.water_level'), name: 'WaterLevel', img_src: 'https://dashboard.fixeau.com/selector-images/ground_water.png', unit: 'm'},
          {title_name: i18n.t('parameters.temperature'), name: 'T', img_src: 'https://dashboard.fixeau.com/selector-images/temperature.png', unit: '°C'},
          {title_name: i18n.t('parameters.ph'), name: 'pH', img_src: 'https://dashboard.fixeau.com/selector-images/ph.png', unit: ''},
          {title_name: i18n.t('parameters.no3'), name: 'NO3', img_src: 'https://dashboard.fixeau.com/selector-images/no3.png', unit: 'mg/l'},
          {title_name: i18n.t('parameters.oxygen'), name: 'O2', img_src: 'https://dashboard.fixeau.com/selector-images/no3.png', unit: '%'},
          {title_name: i18n.t('parameters.soil_moisture'), name: 'SoilMoisture', img_src: 'https://dashboard.fixeau.com/selector-images/soil_moisture.png', unit: '%'},
          {title_name: i18n.t('parameters.precipitation'), name: 'Precipitation', img_src: 'https://dashboard.fixeau.com/selector-images/precipitation.png', unit: 'mm'},
          {title_name: i18n.t('parameters.radiation'), name: 'SolarRadiation', img_src: 'https://dashboard.fixeau.com/selector-images/radiation.png', unit: 'W/m^2'},
          {title_name: i18n.t('parameters.wind_speed'), name: 'WindSpeed', img_src: 'https://dashboard.fixeau.com/selector-images/wind.png', unit: 'm/s'},
          // {title_name: 'Windrichting', name: 'WindDirection', img_src: 'https://dashboard.fixeau.com/selector-images/wind-direction.png'},
        ],
        selectedInTheSelector: this.mapConfig.selectedInTheSelector.selectedMarkers.get || 'pins',
       //selectedCategories: ['Deep', 'Drain', 'Groundwater', 'Shallow'],
        serieCategories: [
          {title_name: i18n.t('categories.surface_water_deep'), name: 'SurfaceWaterDeep', img_src: require('@/assets/images/diep.png') },
          {title_name: i18n.t('categories.drain'), name: 'Drain', img_src: require('@/assets/images/drain.png') },
          {title_name: i18n.t('categories.groundwater'), name: 'Groundwater', img_src: require('@/assets/images/grondwater.png')},
          {title_name: i18n.t('categories.groundwater_deep'), name: 'GroundwaterDeep', img_src: require('@/assets/images/grondwater_diep.png')},
          {title_name: i18n.t('categories.surface_water'), name: 'SurfaceWater', img_src: require('@/assets/images/ondiep.png')},
          {title_name: i18n.t('categories.soil_top'), name: 'SoilTop', img_src: require('@/assets/images/grondwater.png')},
          {title_name: i18n.t('categories.soil_root'), name: 'SoilRoot', img_src: require('@/assets/images/grondwater_diep.png')},
          {title_name: i18n.t('categories.soil_root_deep'), name: 'SoilRootDeep', img_src: require('@/assets/images/grondwater_diep.png')},
          {title_name: i18n.t('categories.groundwater_top'), name: 'GroundwaterTop', img_src: require('@/assets/images/grondwater_diep.png')},
          {title_name: i18n.t('categories.no_category'), name: null, img_src: require('@/assets/images/uncategorised.png')},
        ],
        showParameterSeries: false,
        checkUnit: '',
        selectedInTheSelectorBaselayer: this.mapConfig.selectedInTheSelector.baselayer.get,
        oldSelectedInTheSelectorBaselayer: '',
        selectedInTheSelectorOverlaylayers: this.mapConfig.selectedInTheSelector.overlaylayer.get,
        selectedInTheSelectorCategories: this.mapConfig.selectedInTheSelector.selected_categories.get,
        selectedInTheSelectorTimedimension: this.mapConfig.selectedInTheSelector.selected_timedimension.get,

        timediminesionList: [
            {
                id: 1, name: i18n.t('map.groundwater_forecast'), src: 'https://dashboard.fixeau.com/selector-images/legger.png',
                config: {
                    wms: "http://model.fixeau.com/thredds/wms/bmw/gws.nc",
                    period: "P1D"
                },
                showInCategory: ['SurfaceWaterDeep', 'Drain',  'GroundwaterDeep', 'Groundwater', 'SurfaceWater', 'SoilTop' , null]
            },
            /*{   id: 2, name: 'Voorspelling<br /> ondiep', src: 'https://dashboard.fixeau.com/selector-images/legger.png',
                config: {
                    wms: "http://model.fixeau.com/thredds/wms/bmw/gws.nc",
                    period: "P1D"
                },
                showInCategory: ['SurfaceWaterDeep', 'Drain', 'Groundwater', 'SurfaceWater', 'SoilTop' , null]
            }*/
        ],

        selectedMapPin: {},
        pinModalWidth: 480,
        oldPinLayer: "",
        selectedDeviceIcon: {},
        oldPinFeature: "",
        currentLegend: {},
        selectedLegend: "Bodemkaart",
        currentTimeseries: null,
        itemsBasketLocal: [],
        markerGroupOfCheckmarks: {},
        showBasketAlert: false,
        scadaSecrets: {
          'client_id': 'QeDOSCorXAlLqtcxNrY0.hhdelfland.nl',
          'client_secret': '6sBhbk5C0mTRaQsHckwk',
          'username': 'scherm@hhdelfland',
          'password': 'rZBYRyxvafZwHnYg33Oa'
        },
        timeFilter: null,  // Holds the selected choice in the time filter.
        boardName: '',
        isMounted: false,
        showTimedimension: false,
        latestLayer: null
      };
    },
    watch: {
      selectedInTheSelectorBaselayer(newVal, oldVal) {
        this.mapConfig.selectedInTheSelector.baselayer.set(newVal);
        this.oldSelectedInTheSelectorBaselayer = oldVal;
      },
      selectedInTheSelectorOverlaylayers(newVal) {
        this.mapConfig.selectedInTheSelector.overlaylayer.set(newVal);
      },
      itemsBasketLocal(newArray) {
        this.$store.commit('clearBasket')
        newArray.forEach(item => {
          this.addItemBasket(item)
        })
      },
      selectedInTheSelector(newValue) {
        this.$store.dispatch('retrieveTimeseries').then(() => {
          this.selectedInTheSelectorCallback(newValue);
        });
      },
      selectedInTheSelectorCategories(newValue) {
        this.mapConfig.selectedInTheSelector.selected_categories.set(newValue);
        this.updateTimeseriesOnMap();
        //this.refreshSelectedTimedimensions();
      },
      selectedInTheSelectorTimedimension(newValue) {
        this.mapConfig.selectedInTheSelector.selected_timedimension.set(newValue);
      },

      chartOneVisible: function (val) {
          let vm = this;
          if (!val) {
              vm.chartOneSeries.forEach(serie => {
                  serie.marker.fire('click');
              });
              vm.chartOneSeries = [];

          } else {
              vm.resizeChart();
          }
      },
      chartTwoVisible: function (val) {
          let vm = this;
          if (!val) {
              vm.chartTwoSeries.forEach(serie => {
                  serie.marker.fire('click');
              });
              vm.chartTwoSeries = [];
          } else {
              vm.resizeChart();
          }
      },
      selectedChart:  function(val){
        let vm = this;
        if( val != null) {
          vm.refreshMarkers();
          if(val != undefined && val.activeParameter && val.activeParameter != vm.selectedInTheSelector) {
            vm.selectedInTheSelector = val.activeParameter;
            this.updateTimeseriesOnMap();
          }
        }
      },

      deep: true
    },
    computed: {
      config() {
        return this.$store.state.config
      },
      pinsPoints() {
        return this.$store.state.pinsPoints
      },
      checkHandheldsDisplay() {

        return (this.timeseries !== null  && this.selectedInTheSelector === 'pins' && this.handHeldDataLoaded);
      },
      checkPinsDisplay() {
        return (this.pinsPoints.features !== undefined  && this.selectedInTheSelector === 'pins' && this.handHeldDataLoaded);
      },
      countBasket() {
        return this.$store.getters.countBasket
      },
      itemsBasket() {
        return this.$store.getters.itemsBasket
      },
      parameterSeries() {

        return {
                  type: "FeatureCollection",
                  features: (this.timeseries.features[0] && this.timeFilter)
                            ? this.timeseries.features.filter(t => new Date(t.latest.time) > this.startDate(this.timeFilter))
                            : this.timeseries.features
                }
      },
      grayTimeseries() {
            return {
                type: "FeatureCollection",
                features: (this.timeseries.features[0] && this.timeFilter)
                    ? this.timeseries.features.filter(t => new Date(t.latest.time) < this.startDate(this.timeFilter))
                    : {}
            }
        },

      isMobile() {
        if (window.innerWidth <= 800) {
            return true;
        }
        return false;
      },
      preferSurfaceLevel()  {
        if ( this.$store.state.preferSurfaceLevel) {
          return this.$store.state.preferSurfaceLevel;
        }
        return false;
      },
      isSimple() {
        return this.$store.state.isSimple;
      }
    },
    methods: {
      fitBounds() {
        if (this.mapConfig.page === 'main_map_container') {
          let map = this.$refs.map.mapObject;
          if (map.getZoom() <= 4) {
            let bounds = L.geoJson(this.timeseries).getBounds();
            if (bounds.isValid()) {
              map.fitBounds(bounds);
            }
          }
        }
      },
      updateTimeseriesOnMap() {
          this.handHeldDataLoaded = false

          let parsedSeries = {};
          parsedSeries = Object.assign({}, this.$store.state.timeseries);

          let vm = this;
          if ( vm.selectedInTheSelector == "pins") {
              vm.showParameterSeries = false;

              let features = [];

              for (let parameterAttribute in parsedSeries) {
                  let newFeatures = parsedSeries[parameterAttribute].features;
                  features = features.concat(newFeatures);
              }
              if (features && features.length > 0) {
                this.timeseries =  {
                    type: "FeatureCollection",
                    features: features
                };
                vm.handHeldDataLoaded = true;
                this.fitBounds();
              }
              return;
          }

          vm.showParameterSeries = true;


          let parameter = vm.selectedInTheSelector;
          if (parameter == 'WaterLevel' && !this.$store.state.preferSurfaceLevel) {
              parameter = parameter+"NAP";
          }


          if (!parsedSeries ||   parsedSeries[parameter] == undefined) {
              this.timeseries = {  type: "FeatureCollection",
                  features: []};
              return;
          }
          let series = Object.assign({}, parsedSeries[parameter]);
          if (vm.selectedInTheSelectorCategories && vm.selectedInTheSelectorCategories.length > 0) {
              if (parameter == 'WaterLevel' || parameter == 'WaterLevelNAP') {
                  let categories = vm.selectedInTheSelectorCategories.filter(category => category != 'Shallow' &&  category != "Deep");
                  if (categories.length > 0) {
                      if ( vm.selectedInTheSelectorCategories.includes("Oppervlakte water")) {
                          series.features = series.features.filter(serie => serie.category == "Shallow" || serie.category == "Deep" || categories.includes(serie.category));
                      } else {
                          series.features = series.features.filter(serie => categories.includes(serie.category));
                      }
                  }
              } else {
                  series.features = series.features.filter(serie => vm.selectedInTheSelectorCategories.includes(serie.category));
              }
          }

          series = JSON.parse(JSON.stringify(series));
          series.features = JSON.parse(JSON.stringify(series.features));

          this.timeseries = {
              type: "FeatureCollection",
              features: (series.features && series.features.length > 0) ? series.features : []
          };
          this.fitBounds();

          return;

      },

      parameterChanged(layer) {
        this.filterTimeseries(layer.name);
      },
      selectChart(chart) {
        this.selectedChart = this.$refs[chart];
      },
      selectedInTheSelectorCallback(newValue) {
          let vm = this;
          if (vm.selectedChart != null && vm.selectedChart.activeParameter != newValue) {
              vm.selectedChart = null;
          }

          if (this.mapConfig.page === 'main_map_container') {
              this.refreshMarkers();
              this.itemsBasketLocal = []
              this.$store.commit('clearBasket')
              this.$store.commit('clearTimeseriesBasket')
          }

          this.refreshSelectedCategories();
          this.mapConfig.selectedInTheSelector.selectedMarkers.set(newValue);

          this.updateUnit();
          this.updateTimeseriesOnMap();

          if (newValue !== 'pins') {
              this.updateLegend();
          } else {
              this.resetTimeFilter();
          }
      },
      refreshMarkers(){
          let vm = this;
          this.removeAllMarkers();
          if (this.selectedChart != null) {
              if (this.selectedChart.first) {
                  this.chartOneSeries.forEach(serie => {
                      vm.addIconForSerie(serie, this.$refs.chart_component, true)
                  });
              } else {
                  this.chartTwoSeries.forEach(serie => {
                      vm.addIconForSerie(serie, this.$refs.chart_component_2, true)
                  });
              }
          }
        },
        getMarker(source, latlng, color, extraOptions) {
            let options = {
                weight: 1.5,
                color: "#FFFFFF",
                fillColor: color,
                fillOpacity: 1
            };

            //Merge options.
            if (extraOptions)  {
                options = JQUERY.extend({}, options, extraOptions);
            }

            if (source == 'FixeauPin') {
                options.rotation = 0;
                options.shape = "triangle";
                options.radius = 7;
                return  L.shapeMarker(latlng, options);
            } else if(source == 'FixeauMobile' || source == 'AkvoMobile') {
                options.radius = 8;
                options.renderer = canvasRenderer;
                return L.circleMarker(latlng, options);

            } else {
                delete options.renderer;
                options.shape = "square";
                options.radius = 7;
                return L.shapeMarker(latlng, options);
            }
        },
        getFeatureColor(feature) {
            let vm = this;

            let parameter = feature.parameter;
            let surfaceLevel = vm.$store.state.preferSurfaceLevel;

            if (parameter == "WaterLevel" && surfaceLevel != "true"){
                parameter = "WaterLevelNAP";
            }

            let colorClasses = [];
            let legendConfig= JSON.parse(localStorage.getItem('legends-config'))[parameter];
            if (legendConfig != null) {
                colorClasses = legendConfig.choices;
            }

            let colorFor = value => {
                const item = colorClasses.find(item => value < item.max)
                return item ? item.color : 'black'
            }
            return  colorFor(feature.latest.value);
        },


        resizeChart () {
          let vm = this;
            setTimeout(function() {
                if( document.getElementById('chart-container-wrapper') != null) {
                    let height = document.getElementById('chart-container-wrapper').offsetHeight;

                    if (vm.chartOneVisible) {
                        vm.$refs.chart_component.$children[0].chart.reflow();
                        vm.$refs.chart_component.$children[0].chart.update({chart: {height: height}});
                    }

                    if (vm.chartTwoVisible) {
                        vm.$refs.chart_component_2.$children[0].chart.reflow();
                        vm.$refs.chart_component_2.$children[0].chart.update({chart: {height: height}});
                    }
                }
            }, 100);

        },
      lastMonthDate () {
        let d = new Date();
        let newMonth = d.getMonth() - 1;
        if(newMonth <= 0){
            newMonth += 12;
            d.setFullYear(d.getFullYear() - 1);
        }
        d.setMonth(newMonth);
        return d
      },
      lastWeekDate () {
        const dateNow = new Date()
        const lastWeek = new Date(dateNow - (7*24*3600*1000))
        return lastWeek
      },
      lastDayDate () {
        const dateNow = new Date()
        const yesterday = new Date(dateNow - (24*3600*1000))
        return yesterday
      },
      startDate(timeFilter) {
        return {
          lastMonth: this.lastMonthDate,
          lastWeek: this.lastWeekDate,
          lastDay: this.lastDayDate
        }[timeFilter]();
      },
      applyTimeFilter(timeFilter) {
        this.timeFilter = timeFilter;
        //--------put filtered gray markers in the back--------------
        this.$refs.grayTimeseriesGeojson.mapObject.bringToBack();

      },
      resetTimeFilter() {
        this.timeFilter = null;
        this.grayTimeseries.features = {};
      },
      toggleTimeFilter(timeFilter) {
        if (this.timeFilter != timeFilter) {
          this.applyTimeFilter(timeFilter);
        }
        else {
          this.resetTimeFilter();
        }
      },
      scadaFunction () {
        const scadaSecrets = this.scadaSecrets;

        const qs = require('qs');
        const requestBody = qs.stringify({
          client_id: scadaSecrets['client_id'],
          client_secret: scadaSecrets['client_secret'],
          grant_type: 'password',
          username: scadaSecrets['username'],
          password: scadaSecrets['password']
        });
        const url = 'https://www.telecontrolnet.nl/oauth/token';
        return new Promise(function(resolve) {
          JQUERY.ajax({type: "POST",url:url,data:requestBody})
            .then((response) => {
              resolve(response.access_token)
            })
        })
      },
      updateZoom (zoom) {
        if (this.mapConfig.page === 'main_map_container') {
          localStorage.setItem('zoom', JSON.stringify(zoom));
        }
      },
      updateCenter (center) {
        if (this.mapConfig.page === 'main_map_container') {
          localStorage.setItem('center', JSON.stringify(center));
        }
      },
      loadZoom() {
        if (this.mapConfig.page === 'main_map_container') {
          let localZoom = localStorage.getItem('zoom');
          if (localZoom) {
            this.zoom = JSON.parse(localZoom);
          }
          let localCenter = localStorage.getItem('center');
          if (localCenter) {
            this.center = JSON.parse(localCenter);
          }
        }
        else {
          if (this.mapConfig.zoom) {
            this.zoom = this.mapConfig.zoom;
          }
          if (this.mapConfig.center) {
            this.center = this.mapConfig.center;
          }
        }
      },
      updateLegend() {
        if (this.selectedInTheSelector == "WaterLevel" && !this.$store.state.preferSurfaceLevel) {
          this.currentLegend = this.config.legend_config["WaterLevelNAP"];
        } else {
          this.currentLegend = this.config.legend_config[this.selectedInTheSelector];
        }
      },
      showModalSelectors () {
        this.$modal.show('controllerModalSelector');
      },
      showModalLegends () {
        this.$store.dispatch('retrieveConfig')
          .then(() => {
            this.$modal.show('controllerModalLegends');
          });
      },
      showModalChart() {
        this.$modal.show('controllerModalChart');
      },
      showSaveToBoardModal() {
        this.$modal.show('saveToBoardModal');
      },
      serialize() {
        let mapObject = this.$refs.map.mapObject;
        let center = mapObject.getCenter();
        return {
          center: {lat: center.lat, lng: center.lng},
          zoom: mapObject.getZoom(),
          timeFilter: this.timeFilter,
          baseLayer: this.selectedInTheSelectorBaselayer,
          overlayLayers: this.selectedInTheSelectorOverlaylayers,
          parameter: this.selectedInTheSelector,
          categories: this.selectedInTheSelectorCategories,
          timedimension: this.selectedInTheSelectorTimedimension
        };
      },
      saveToBoard() {
        /* Save the current setup as a Board to the backend. */
        this.saveBoardErrors = [];
        if(this.boardName.length == 0) {
            this.saveBoardErrors.push(i18n.t('map.board_name_cannot_be_empty'));
        }

        if(this.boardName.length > 32) {
            this.saveBoardErrors.push(i18n.t('map.board_name_max_characters'));
        }

        if (this.saveBoardErrors.length == 0 ){
            let maps = [this.serialize()];
            let charts = [
              this.$refs.chart_component,
              this.$refs.chart_component_2
            ].filter(c => c != undefined).map(c => c.serialize());
            let board = {
              name: this.boardName,
              config: {maps: maps, charts: charts}
            };
            axios.post('/board/', board).then(() => {
                this.$store.dispatch('retrieveBoards');
            });

            this.$modal.hide('saveToBoardModal');
            this.showAlertBox(i18n.t('map.board_was_saved'), i18n.t('map.board_was_saved2'));
        }
      },
      addSecondChart(){
        let vm = this;
        if (this.chartOneVisible) {
            this.chartTwoVisible = true;
            //Have to set a timeout so $refs isnt undefined
            setTimeout(function () {
              vm.selectedChart = vm.$refs.chart_component_2;
            } ,100)
        } else {
            this.chartOneVisible = true;
            //Have to set a timeout so $refs isnt undefined
            setTimeout(function () {
                vm.selectedChart = vm.$refs.chart_component;
            } ,100)
        }

      },
      toggleSurfaceLevel () {
        //Temporarily disable toggleSurfaceLevel button to avoid multiple requests:
        if (!this.allowToggleSurfaceLevel) return;
        this.allowToggleSurfaceLevel = false;

        let preferSurfaceLevel = !this.$store.state.preferSurfaceLevel;

        this.$store.commit("preferSurfaceLevel",   preferSurfaceLevel )
        this.reloadAfterSurfaceLevel(preferSurfaceLevel);
        this.updateTimeseriesOnMap();
      },
      reloadAfterSurfaceLevel () {
          this.$store.dispatch('retrieveTimeseries', this.selectedInTheSelector).then(() => {
              this.filterTimeseries(this.selectedInTheSelector);
              this.updateLegend();
              this.allowToggleSurfaceLevel=true;
              if (this.$refs.chart_component !== undefined) {
                  this.$refs.chart_component.reloadChart();
              }

              if (this.$refs.chart_component_2 !== undefined) {
                  this.$refs.chart_component_2.reloadChart();
              }
          });
      } ,
      addItemBasket (newItem) {
        this.$store.dispatch('addItemBasket', newItem)
          .then(() => {
            //console.debug(`item ${item} added`)
          })
          .catch(() => {
            this.showBasketAlert = true
            this.itemsBasketLocal = this.$store.getters.itemsBasket
          });
      },
      clearBasket () {
        this.$store.commit('clearBasket')
        this.itemsBasketLocal = []
        this.markerGroupOfCheckmarks.clearLayers()
        this.showBasketAlert = false;
      },
      filterTimeseries(layer) {
        let vm = this;
        return new Promise (function(resolve) {
          if (vm.timeseries && !vm.timeseries.features) {
            vm.timeseries.features = vm.timeseries
          }

          vm.mapConfig.selectedInTheSelector.selectedMarkers.set(layer);

          vm.updateUnit();
          resolve();
        })
      },
      initLayers: function () {
        let base_layers = this.config.layer_config.base_layers;
        const targetLayer = base_layers.find(layer => layer.name === this.selectedInTheSelectorBaselayer);

        if (targetLayer != undefined) {
          this.onLayersChange(targetLayer.id, targetLayer.visible, base_layers, true)
            this.oldSelectedInTheSelectorBaselayer = targetLayer.name;
        }
        let overlay_layers = this.config.layer_config.overlay_layers;
        if (this.selectedInTheSelectorOverlaylayers) {
          this.selectedInTheSelectorOverlaylayers.forEach(selected => {
            overlay_layers.forEach(overlay => {
              if(overlay.id === selected) {
                this.onLayersChange(overlay.id, false, overlay_layers)
              }
            })
          })
        }
        let selectedCategories = this.mapConfig.selectedInTheSelector.selected_categories.get;
        if (selectedCategories !== undefined && selectedCategories.length > 0) {
            this.selectedInTheSelectorCategories = selectedCategories;
        }

          let selectedTimedimension = this.mapConfig.selectedInTheSelector.selected_timedimension.get;
          if (selectedTimedimension !== undefined && selectedTimedimension.length > 0) {
              this.selectedInTheSelectorTimedimension= selectedTimedimension;
          }

        let selectedParameter = this.mapConfig.parameter;
        if (selectedParameter) {
          this.selectedInTheSelector = selectedParameter;
        }

      },
      onEachFeaturePopupTimeseries: function (feature, layer) {
        let vm = this;
        function whenClicked(e) {
            //Check if double click.
            if(!e.originalEvent.detail || e.originalEvent.detail == 1) {
                if (!vm.isMobile) {
                    //Show chart one when none is visible.
                    if (!vm.chartOneVisible && !vm.chartTwoVisible) {
                        //vm.chartOneVisible = true;
                        vm.showModalChart();
                    }

                    if (vm.selectedChart === undefined || vm.selectedChart == null) {
                        if (!vm.chartOneVisible) {
                            vm.chartOneVisible = true;
                            setTimeout(function () {
                                vm.selectedChart = vm.$refs.chart_component;
                                vm.addSerieToChart(feature);
                            }, 350);
                        } else if (!vm.chartTwoVisible) {
                            vm.chartTwoVisible = true;
                            setTimeout(function () {
                                vm.selectedChart = vm.$refs.chart_component_2;
                                vm.addSerieToChart(feature);
                            }, 350);
                        } else {
                            vm.showAlertBox(i18n.t('map.warning'), i18n.t('map.no_chart_selected'));
                        }
                    } else {
                        vm.addSerieToChart(feature);
                    }
                } else {
                    vm.$modal.show('timeseriesModal');
                    vm.currentTimeseries = feature;
                }
            } else { // Double click, do nothing.
                return false;
            }
        }
        layer.on({
            click: whenClicked,
        });
      },
      addSerieToChart(feature, checkForSameLocationSeries=true){
          let vm = this;
          if (checkForSameLocationSeries) {
              vm.addSeriesOnSameLocation(feature);
          }

          if (vm.selectedChart.activeSeries.length < 4) {
              vm.loadSerieOnChart(feature, vm.selectedChart)
              vm.addIconForSerie(feature, vm.selectedChart)
              vm.resizeChart();

          } else {
              vm.showAlertBox(i18n.t('map.warning'), i18n.t('map.select_max_4'));
          }
      },
    addSeriesOnSameLocation(feature) {
        this.getSameLocationSeries(feature).forEach(serie => {
            serie.sameLocationSerie = true;
            this.addSerieToChart(serie, false);
        });

    },
    addIconForSerie(feature, chart, ignoreAdd=false){
        let vm = this;
        let coordinates = feature.geometry.coordinates;

        let marker =  L.marker([coordinates[1], coordinates[0]], {icon: checkmarkTimeseries}).addTo(vm.markerGroupOfCheckmarks);

        let className = (feature.data_source == 'FixeauPin') ? 'triangle-marker' : 'circle-marker';
        marker._icon.classList.add(className);

        let series =  JQUERY.extend(true, [], feature);  // Quick fix to avoid "too much recursion" error (caused by dependencies in computed?)
        series.marker_id = marker._leaflet_id;
        series.marker = marker;
        series.marker_id = marker._leaflet_id;
        feature.marker = marker;

        marker.setZIndexOffset(800);
        marker.bindTooltip(formatMarkerInfo(feature),{permanent:false,className:"label",opacity:0.7,direction:"top",offset:[0, -8]});


        if(!ignoreAdd) {
          if (chart.first) {
              this.chartOneSeries.push(series);
          } else {
              this.chartTwoSeries.push(series);
          }
        }

      marker.on('click', function(e){ unselectTimeseries(e, this, chart, feature.id); });
         //Deselecting a series method:
          function unselectTimeseries(e, layer, chart, id) {
            vm.$refs.map.mapObject.removeLayer(layer);
            chart.removeSeries(id);
            if (chart.first) {
                vm.chartOneSeries = vm.chartOneSeries.filter(arrayItem => arrayItem.id !== id);
                if(vm.chartOneSeries.length == 0) {
                    vm.selectedChart = null;
                    vm.chartOneVisible = false;
                }
            } else {
                vm.chartTwoSeries = vm.chartTwoSeries.filter(arrayItem => arrayItem.id  !== id);
                if(vm.chartTwoSeries.length == 0) {
                    vm.selectedChart = null;
                    vm.chartTwoVisible = false;
                }
            }

            let feature =  vm.timeseries.features.find(serie =>  serie.id == id);

            // Only fire if its the main serie, else we get a recursive loop.
            if (feature !== undefined && !feature.sameLocationSerie) {
                vm.removeSeriesSameLocation(feature)
            }
          }
      },
      removeSeriesSameLocation(feature) {
        this.getSameLocationSeries(feature).forEach(serie => {
            serie.marker.fire('click');
        });
      },
      getSameLocationSeries(feature) {
          return this.parameterSeries.features.filter(  serie => serie.geometry.coordinates[0] == feature.geometry.coordinates[0]  &&
              serie.geometry.coordinates[1] == feature.geometry.coordinates[1] &&
              serie.id != feature.id );
      },
      loadSerieOnChart(feature, chart){
        axios.get('/series/' + feature.id + '/').then(response => {
            chart.load(response.data);
        });
      },
      removeAllSelectedSeries(){
          this.markerGroupOfCheckmarks.clearLayers();
      },
      showAlertBox(title, text) {
        this.$modal.show('dialog', {
          title: title,
          text: text,
          buttons: [
            {
              title: i18n.t('map.ok')
            }
          ]
        });
      },
      goToMeasurements: function () {
        this.$router.push({ name: "measurementsList", params: { id: this.currentTimeseries.id, seriesName: this.currentTimeseries.name, latest: this.currentTimeseries.latest, parameter: this.currentTimeseries.parameter }})
      },
      onChangingSelectedTimeseries: function (currentTimeseries, doNotAdd) {
        let vm = this;
        function unselectTimeseries() {
          let item = currentTimeseries.id;
          vm.$store.dispatch('removeItemBasket', item).then(() => vm.itemsBasketLocal = vm.itemsBasket);
          vm.$store.dispatch('removeTimeseriesBasket', currentTimeseries);
          vm.$refs.map.mapObject.removeLayer(this);
        }
        if (vm.itemsBasketLocal.length < 4) {
          let coordinates = currentTimeseries.geometry.coordinates;
          L.marker([coordinates[1], coordinates[0]], {icon: checkmarkTimeseries}).addTo(vm.markerGroupOfCheckmarks).on('click', unselectTimeseries);
          if (!doNotAdd) {
            vm.$store.dispatch('addTimeseriesBasket', currentTimeseries)
          }
        }
        setTimeout(function () {
          vm.$modal.hide('timeseriesModal');
        } ,800)
      },
      onEachFeaturePopupPins: function (feature, layer) {
        //let PopupCont = Vue.extend(PopupContent);
        //let popup = new PopupCont({ propsData: { type: feature.geometry.type, text: `I am ${feature.properties.name}` } });
        //layer.bindPopup(popup.$mount().$el);
        let vm = this;
        function whenClicked() {
          let groupedData = _.groupBy(feature.properties.values, 'parameter_name');
          vm.pinModalWidth = _.size(groupedData) * 85;

          vm.selectedMapPin = groupedData;
          vm.$modal.show('pinModal');
          let activePinIcon = {
              className: 'my-div-icon-pin',
              html: `<img class="my-div-image" src="${require('@/assets/images/pin_active.png')}"/>`,
              // be carefull with the size to be exactly as the original.
              iconSize: [21, 40],
              // be carefull with the anchor otherwise you have a different location.
              iconAnchor: [10.5, 40],
          };
          let pinIcon = {
              className: 'my-div-icon-pin',
              html: `<img class="my-div-image" src="${require('@/assets/images/pin.png')}"/>`,
              // be carefull with the size to be exactly as the original.
              iconSize: [21, 40],
              // be carefull with the anchor otherwise you have a different location.
              iconAnchor: [10.5, 40],
          };
          let icon2 = new L.DivIcon(activePinIcon);
          layer.setIcon(layer.options.icon = icon2);
          // keep a reference to switch the icon back on the next click
          vm.selectedDeviceIcon = pinIcon;
          vm.oldPinLayer = layer;
          vm.oldPinFeature = feature
        }
        layer.on({
            click: whenClicked,
        });
      },
      onEachFeaturePopupHandhelds: function (feature, layer) {
        let vm = this;
        function whenClicked() {
          let groupedData = _.groupBy([feature.latest], 'parameter_name');
          vm.pinModalWidth = _.size(groupedData) * 85;
          vm.selectedMapPin = groupedData;
          vm.$modal.show('pinModal');
          let activeHandheldIcon = {
              className: 'my-div-icon-handheld',
              html: `<img class="my-div-image" id="active_pin" src="${require('@/assets/images/probe_active.png')}"/>`,
              iconSize: [18, 36],
              iconAnchor: [9, 36],
          };
          let handheldIcon = {
              className: 'my-div-icon-handheld',
              html: `<img class="my-div-image" id="active_pin" src="${require('@/assets/images/probe.png')}"/>`,
              iconSize: [18, 36],
              iconAnchor: [9, 36],
          };
          let icon3 = new L.DivIcon(activeHandheldIcon);
          layer.setIcon(layer.options.icon = icon3);
          // keep a reference to switch the icon back on the next click
          vm.selectedDeviceIcon = handheldIcon;
          vm.oldPinLayer = layer;
          vm.oldPinFeature = feature
        }
        layer.on({
            click: whenClicked,
        });
      },
      beforeClose: function() {
          let vm = this;
          // only attempt to change oldPinLayer icon back to original if oldPinLayer defined
          if (vm.oldPinLayer) vm.oldPinLayer.setIcon(vm.oldPinLayer.options.icon = new L.DivIcon(vm.selectedDeviceIcon));
      },
      onLayersChange: function (layerId, visible, layers, init=false) {
          let vm = this;

          this.$nextTick(function () {

              const layer = layers.find(layer => layer.id === layerId);
              if (layer.type === "base") {
                  let baselayer;
                  if (layer.attribution) {
                      baselayer = L.tileLayer(layer.url, {
                          attribution: layer.attribution,
                          useCache: true,
                          crossOrigin: true
                      });
                  } else if (layer.subdomains) {
                      baselayer = L.tileLayer(layer.url, {
                          subdomains: layer.subdomains,
                          useCache: true,
                          crossOrigin: true
                      });
                  }
                  layer.instance = baselayer;

                  vm.$refs.map.mapObject.addLayer(baselayer);
                  if (this.selectedInTheSelectorOverlaylayers.length > 0) {
                      baselayer.bringToBack();
                  }

                  if (this.oldSelectedInTheSelectorBaselayer != "") {
                        const oldLayer = layers.find(layer => layer.name === this.oldSelectedInTheSelectorBaselayer);
                        if(!init) {
                           if (vm.$refs.map.mapObject.hasLayer(oldLayer.instance)) {
                                vm.$refs.map.mapObject.removeLayer(oldLayer.instance);
                            }
                        }
                      vm.$refs.map.mapObject.addLayer( vm.markerGroupOfCheckmarks);
                  }
              } else {
                  layer.visible = !visible;

                  if (layer.visible) {
                      if (layer.name.toLowerCase() === 'scada') {
                          this.scadaFunction().then(token => {
                              scada.loadScada(token).done(layerScada => {
                                  layer.instance = layerScada;
                                  vm.$refs.map.mapObject.addLayer(layerScada);
                              })
                          })
                      } else {
                          let params = {
                              layers: layer.serverName,
                              format: 'image/png',
                              transparent: layer.transparent,
                              opacity: layer.opacity,
                              GetFeatureInfo: layer.GetFeatureInfo,
                              useCache: true,
                              crossOrigin: true

                          }
                          if (layer.tileSize) {
                            params.tileSize = layer.tileSize
                          }

                          let overlaylayer = L.tileLayer.wms(layer.url, params);

                          layer.instance = overlaylayer;
                          let map = vm.$refs.map.mapObject;
                          map.addLayer(overlaylayer);
                          this.latestLayer = layer;
                          if (layer.isModelRunLayer) {
                            layer.modificationLayers = scenarioMapHelper.createModificationLayers(map, layer);
                          }
                      }
                  } else {
                      if(vm.$refs.map.mapObject.hasLayer(layer.instance)) {
                          vm.$refs.map.mapObject.removeLayer(layer.instance);
                          if (layer.isModelRunLayer) {
                            layer.modificationLayers.forEach(function (modificationLayer) {modificationLayer.remove()});
                          }
                          if (this.latestLayer == layer) {
                            this.latestLayer = null;
                          }
                      }
                  }
              }
          });

      },
        onTimedimensionChange: function(event, timedimension) {
          if (!this.selectedInTheSelectorTimedimension.includes(timedimension.name)) {
              if (this.selectedInTheSelectorTimedimension.length > 0 ){
                  this.$refs.timedimension.hideTimedimension();
              }

              this.selectedInTheSelectorTimedimension = [];
              this.selectedInTheSelectorTimedimension.push(timedimension.name);

              this.$refs.timedimension.showTimedimension(timedimension.config);
          } else {
              this.selectedInTheSelectorTimedimension = [];
              this.$refs.timedimension.hideTimedimension();
          }
      },
        patchMapConfig: function() {
            let vm = this;

            //Need to use JQUERY too deep clone object, JSON.stringify gives errors because the objects are nested too deep.
            var copyOfOverlayLayers = JQUERY.extend(true, [], this.config.layer_config.overlay_layers );
            let overlay_layers =  copyOfOverlayLayers.map(function(item) {
                delete item.modificationLayers;
                delete item.instance;
                item.visible = vm.selectedInTheSelectorOverlaylayers.includes(item.id);
                return item;
            });

            var copyOfBaseLayers = JQUERY.extend(true, [], this.config.layer_config.base_layers );
            let baselayers = copyOfBaseLayers.map(function(item) {
                delete item.instance;
                item.visible = item.name == vm.selectedInTheSelectorBaselayer;
                return item;
            });

            axios.defaults.headers.common['Authorization'] = 'JWT ' + this.$store.state.token;
            let layer_config = {
                                "overlay_layers": overlay_layers,
                                "base_layers": baselayers,
                                "selected_parameter": this.selectedInTheSelector,
                                "selected_categories": this.selectedInTheSelectorCategories,
                                "selected_timedimension": this.selectedInTheSelectorTimedimension
            }

            axios.patch('/config/me/', {
                "layer_config": layer_config,
            });
        },
      onLegendsChange: function (legend) {
        this.currentLegend = legend;
      },
      removeAllMarkers() {
        this.markerGroupOfCheckmarks.clearLayers();
      },
      isParameterAvailable(parameter) {
            if(parameter == "pins")
                return true;

            if (this.$store.state.profile != null && this.$store.state.profile.details.available_parameters[parameter] !== undefined) {
                return true;
            }
            return false
        },
        isCategoryAvailable(category) {
            //Only show Uncategorised if there are other categories available.
            if(category == null) {
                let availableCategories = 0;
                this.serieCategories.forEach(c=> {
                    if (c.name != null) {
                        if (this.isCategoryAvailable(c.name)) {
                            availableCategories++;
                        }
                    }
                });
                if (availableCategories > 0) {
                    return true;
                }
                return false
            }

            if (this.$store.state.profile != null && this.$store.state.profile.details.available_parameters[this.selectedInTheSelector] !== undefined) {
                return this.$store.state.profile.details.available_parameters[this.selectedInTheSelector].categories.includes(category);
            }
            return false;
        },
        refreshSelectedCategories() {
            let vm = this;
            vm.selectedInTheSelectorCategories = vm.selectedInTheSelectorCategories.filter(category => vm.isCategoryAvailable(category));
        },

        isTimedimensionAvailable(timedimension) {
          let vm = this;
          if (timedimension === undefined) {
              return false;
          }

          if (vm.selectedInTheSelectorCategories.length == 0) {
              return true;
          }

          let td = this.timediminesionList.find(item => item.name == timedimension);

          let returnValue = false;
          vm.selectedInTheSelectorCategories.forEach(category => {
            if (td.showInCategory.includes(category)) {
                returnValue =  true;
            }
          });

          return returnValue;

        },
        refreshSelectedTimedimensions() {
            let vm = this;
            //vm.selectedInTheSelectorTimedimension = vm.selectedInTheSelectorTimedimension.filter(timedimension => vm.isTimedimensionAvailable(timedimension.name));

            let availableList = [];

            vm.selectedInTheSelectorTimedimension.forEach(timedimension => {
                if (vm.isTimedimensionAvailable(timedimension)) {
                    availableList.push(timedimension);
                }
            });

            vm.selectedInTheSelectorTimedimension = availableList;

            if (vm.selectedInTheSelectorTimedimension.length == 0) {
                vm.$refs.timedimension.hideTimedimension();
            }


        },
        updateUnit() {
            let vm = this;
            let parameter = this.pointsControlObject.find(parameter => parameter.name == vm.selectedInTheSelector);
            if (parameter === undefined) {
                vm.checkUnit = '';
            } else {
                vm.checkUnit = parameter.unit;
            }
        }
    }
  };
</script>


<style lang="scss">
  //@import './leaflet-compass/leaflet-compass.css';
  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  @import "~leaflet.locatecontrol/dist/L.Control.Locate.min.css";
  .container_map {
    height: calc(100vh - 70px);
    margin: 0;
  }
  @media screen and (max-width: 800px) {
    .container_map {
      height: 100vh;
    }
  }

  /* buttons on the map */
  %map-button-style {
    position: absolute;
    z-index: 1200;
    left: calc(100% - 64px);
    width: 54px;
    height: 54px;
  }
  #legends {
    @extend %map-button-style;
    top: calc(100% - 90px);
  }
  #legends_main_map {
    @extend %map-button-style;
    top: calc(100% - 154px);
  }
  /* saveToBoard button */
  #save_to_board_btn {
    @extend %map-button-style;
    top: 75px;
    background-image: url("../../assets/images/map_save.png");
  }
  /* Map filter buttons */
  #map_filter_div {
    position: absolute;
    z-index: 1000 !important;
    bottom: 37px;
    left: calc(50% - 102px);
    padding: 3px 8px;
    background-color: #00008c;
    border-radius: 8px;
  }
  #map_filter_div p{
    display: inline;
    color: white;
    font-size: 12px;
    font-weight: 800;
    padding-right: 8px;
  }
  #map_filter_div button {
    font-size: 12px;
    font-weight: 800;
    color: #00008c;
    background-color: white;
    padding: 3px 7px;
    margin-bottom: 2px;
  }
  #map_filter_div button:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  #map_filter_div button:hover {
    border: 1px solid #818181;
  }
  #map_filter_div button.active {
    border: 1px solid #818181;
    background-color: #e2e2e2;
  }
  .main_map_filter_div {
    bottom: 0px !important;
  }
  @media screen and (max-width: 800px) {
    #legends {
      position: fixed;
      bottom: 144px;
      right: 10px;
      z-index: 700;
      left: auto;
      top: auto;
      width: 54px;
      height: 54px;
    }
    #legends_main_map {
      position: fixed;
      bottom: 172px;
      right: 10px;
      z-index: 700;
      left: auto;
      top: auto;
    }
    #map_filter_div {
      position: fixed;
      bottom: 70px !important;
      right: auto;
      left: calc(50% - 101px);
      top: auto;
      margin-bottom: 5px;
    }
  }
  /* #legends {
    position: fixed;
    bottom: 70px;
    right: calc(33.33% + 40px);
    z-index: 2000;
  }
  @media screen and (max-width: 800px) {
    #legends {
      bottom: 144px;
    }
  } */

  #chart_modal_button {
    position: absolute;
    background-image:url("../../assets/images/nap.png");
    z-index: 1200;
    width:54px;
    height:54px;
    left: calc(100% - 64px);
    top: calc(50% - 54px);
  }

  .basket-alert-btn {
    height: 30px;
    background-image: none;
    font-size: 0.8rem !important;
    padding: 0px !important;
    color: #ffe1eb;
    box-shadow: none !important;
  }
  .basket-alert-text {
    color: white;
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 3px;
  }
  .btn-info:not(:disabled):not(.disabled):active:focus {
    box-shadow: none !important;
  }

  /* button selector */
  #prefer_surface_level {
    position: absolute;
    background-image:url('../../assets/images/nap.png');
    z-index: 1200;
    width:54px;
    height:54px;
    left: calc(100% - 64px);
    top: calc(100% - 218px);
  }

  #prefer_surface_level.selected {
    background-image:url('../../assets/images/nap-active.png');
  }

  @media screen and (max-width: 800px) {
    #prefer_surface_level {
      position: fixed;
      bottom: 234px;
      right: 10px;
      z-index: 700;
      left: auto;
      top: auto;
    }
  }

  /* button selector */
  #selectors {
    position: absolute;
    z-index: 1200;
    left: calc(100% - 64px);
    top: calc(100% - 90px);
  }
  @media screen and (max-width: 800px) {
    #selectors {
      position: fixed;
      bottom: 110px;
      right: 10px;
      z-index: 700;
      left: auto;
      top: auto;
    }
  }
  /* #selectors {
    position: fixed;
    bottom: 40px;
    right: 10px;
    z-index: 700;
  }
  @media screen and (max-width: 800px) {
    #selectors {
      bottom: 80px;
    }
  } */
  .btn-primary:not(:disabled):not(.disabled):active:focus {
    box-shadow: none !important;
  }

  /* buttons map center location and compass */
  .leaflet-top {
    position: absolute;
    left: calc(100% - 74px);
    top: 0;
  }
  @media screen and (max-width: 800px) {
    .leaflet-top {
      position: fixed;
      left: auto;
      top: 0;
      right: 0;
    }
  }
  /* .leaflet-top {
    right: 0;
    left: auto;
    top: 70px;
    position: fixed;
  }
  @media screen and (max-width: 800px) {
    .leaflet-top {
      top: 0;
    }
  } */
  .leaflet-control {
    margin-left: 0;
    margin-right: 10px;
  }
  .leaflet-control-attribution {
    font-size: small;
  }
  // .leaflet-bar a {
  //   background-color: transparent !important;
  // }
  .leaflet-control-locate a .leaflet-control-locate-location-arrow {
    content:url(../../assets/images/map_center_location.png);
    width: 54px;
    height: 54px;
    margin: 0;
    mask-image: none;
    background-color: transparent;
  }
  .leaflet-control-locate.active a .leaflet-control-locate-location-arrow {
    background-color: transparent;
  }
  @media screen and (max-width: 800px) {
    .leaflet-control-locate a .leaflet-control-locate-location-arrow {
      float: right;     // quickfix
    }
  }
  .leaflet-compass {
    width: 54px;
    height: 55px;
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
  .compass-icon {
    background-image: none !important;
    content:url(../../assets/images/map_compass.png);
    width: 54px !important;
    height: 55px !important;
    margin: 0 !important;
    cursor: hand;
    cursor: pointer;
  }
  .compass-button.active {
    background-color: transparent !important;
  }

  /* badge */
  .badge-container {
    width: 200px;
    margin-left: -90px;
    display: block;
  }
  .badge {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 400 !important;
    font-size: 13px !important;
    line-height: 18px !important;
    padding: 3px 8px 2px 8px !important;
    margin: 6px auto 0 auto;
    white-space: nowrap !important;
    border-radius: 18px !important;
    background-color: #000000 !important;
    display: table !important;
  }

  /* pin info */
  .modalLegends .v--modal-box {
    top: 80px !important;
    height: 130px !important;
    overflow: hidden !important;
    max-width: calc(100% - 30px) !important;
    margin-left: auto;
    margin-right: auto;
    border-radius: 6px !important;
    box-shadow: 0 3px 5px 2px rgba(27, 33, 58, 0.4) !important;
    position: fixed !important;
  }
  .modalTimeseries .v--modal-box {
    top: 80px !important;
    height: 125px !important;
    overflow: hidden !important;
    max-width: calc(100% - 20px) !important;
    margin-left: 10px !important;
    margin-left: auto;
    margin-right: auto;
    border-radius: 6px !important;
    box-shadow: 0 3px 5px 2px rgba(27, 33, 58, 0.4) !important;
    position: fixed !important;
  }
  .modalTimeseries h3 {
    height: 63px !important;
    font-size: 1.5rem !important;
    margin-bottom: 0.5rem !important;
    font-weight: 600 !important;
  }
  @media screen and (max-width: 800px) {
    .modalLegends .v--modal-box {
      overflow-x: auto !important;
      bottom: 80px;
      top: auto !important;
    }
    .modalLegends .v--modal-box a {
      display: table-cell;
    }
    .modalTimeseries .v--modal-box {
      overflow-x: auto !important;
      top: 5px !important;
      bottom: auto !important;
    }
    .modalTimeseries .v--modal-box a {
      display: table-cell;
    }
  }
  .v--modal-overlay {
    position: fixed !important;
    background: rgba(64, 64, 64, 0.2) !important;
    animation-duration: 0.6s;
    bottom: 0;
    height: auto !important;
  }
  .v--modal-overlay[data-modal="controllerModalLegends"] {
    background: transparent !important;
  }
  .modalLegends {
    z-index: 1100 !important;
  }
  .controllerModalSelector, .controllerModalLegends, .modalTimeseries {
    z-index: 2100 !important;
  }

  .controllerModalChart {
    top:70px !important;
  }

  .controllerModalChart .v--modal {
    background-color: transparent !important;
    height: calc(100vh - 70px) !important;
  }

  .v--modal-overlay[data-modal="controllerModalChart"] {
    pointer-events: none;
    background: transparent !important;;
    width:600px;
  }

  .controllerModalChart .v--modal main {
    cursor:pointer;
    pointer-events: auto;
    -webkit-box-shadow:  0px 5px 7px 0px rgba(27, 33, 58, 0.2);
    box-shadow: 0px 5px 7px 0px rgba(27, 33, 58, 0.2);
  }

  .btn-group, .add-new-chart {
    pointer-events: auto;
  }

  .controllerModalChart .v--modal .chart-modal-wrapper {
    position:relative;
    height: calc(49% - 10px);
  }
  .controllerModalChart .v--modal .chart-modal-wrapper-top {
    margin-top: 13px;
  }

  .controllerModalChart .v--modal .map-chart {
    height: 100%;
    width:100%;
  }

  .controllerModalChart .v--modal-box  {
    overflow: visible !important;
  }

  /* Save to board modal */
  .v--modal-overlay[data-modal="saveToBoardModal"] {
    z-index:1000;
  }

  .v--modal-overlay[data-modal="saveToBoardModal"] .v--modal {
    padding:25px;
    box-shadow: 0px 5px 7px 0px rgba(27, 33, 58, 0.2);
  }

  .v--modal-overlay[data-modal="saveToBoardModal"] div {
    float:left;
    position:relative;
    width:100%;
  }

  .v--modal-overlay[data-modal="saveToBoardModal"] h3, p {
    text-align:center;
  }

  .v--modal-overlay[data-modal="saveToBoardModal"] input {
    position:relative;
    text-align:center;
    width:200px;
    left:50%;
    margin-left:-100px;
  }

  .v--modal-overlay[data-modal="saveToBoardModal"] button {
    position:relative;
    text-align:center;
    width:150px;
    left:50%;
    margin-left:-75px;
    margin-top:20px;

    font-family: 'Dosis', sans-serif;
    font-size: 16px;
    font-weight: 400;

    border-radius: 5px;
    border: none;
    color: #ffffff;
    background-color: #2e98fc;
    -webkit-appearance: none;
    cursor: pointer;
  }

  #board_save_error b{
    font-size:14px;
    color:red;
  }

  #board_save_error p{
    font-size:12px;
    color:red !important;
  }

  #board_save_error li{
    list-style-type: none;
  }

  .container_map main > div {
    margin-top: 0px;
  }

  .map-chart .highcharts-container {
    width: auto !important;
  }

  main div, main div svg {
    height: 100%;
  }

  .checked-timeseries {
    font-weight: bold;
    font-size: 11px;
    text-align: center;
    color: #FFF;
  }

  .add-new-chart {
    position: relative;
    z-index: inherit !important;
    width: 45px;
    height: 45px;
    margin-top: 10px;
  }

  .add-new-chart img {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .add_margin {
    margin-top: -25px;
  }

  .map-chart .map-chart-top {
    height: 5% !important;
    float: left;
    width: 100%;
    cursor: pointer;
  }

  .map-chart #chart-container-wrapper {
    height: 89% !important;
    width: 100%;
    float: left;
  }

  .highcharts-component {
    cursor: pointer;
  }

  .map-chart.active  main {
    border: 3px solid #00eb82;
  }

  /* timeseries */
  .timeseries-div-icon .svg {
    height: 20px;
    border-radius: 10px;
    border: 2px solid #ffffff;
    box-shadow: 1px 2px 0px 1px rgba(27, 33, 58, 0.4);
  }
  .timeseries-div-icon .circle {
    fill: #7AF5BE;
  }
  .timeseries-div-icon .text {
    fill: #00008c;
    font-size: 4rem;
    font-weight: 700;
  }
  .dot {
    height: 25px;
    width: 25px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
  }
  .square {
    height: 25px;
    width: 25px;
    background-color: #bbb;
    display: inline-block;
  }

  .triangle {
    width: 0;
    height: 0;
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-bottom: 20px solid #bbb;
    display: inline-block;
  }

  .marker-cluster {
    width: 46px !important;
    height: 52px !important;
    background-image: url(../../assets/images/pin-map.png);
    background-repeat: no-repeat;
    background-position: center top;
    background-color: transparent;
  }
  .marker-cluster div {
    background-color: transparent;
    font-weight: 700 !important;
    width: 46px;
    height: 50px;
    margin: 0;
  }
  .marker-cluster span {
    font-size: 16px;
    line-height: 46px;
    vertical-align: middle;
    font-weight: 700 !important;
    color: #00008c;
  }

  /* ModalSelector and ModalLegenda */
  .row-buttons {
    border-bottom: 1px solid #F2EFE9;
    padding: 10px;
    overflow-x: auto !important;
  }
  .row-buttons:last-child {
    border-bottom: none;
  }
  .controllerModalLegends .v--modal, .controllerModalSelector .v--modal,  .controllerModalChart .v--modal{
    position: fixed !important;
    top: auto !important;
    bottom: 0;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  @media screen and (max-width: 800px) {
    .controllerModalLegends .v--modal, .controllerModalSelector .v--modal {
      left: 0 !important;
      width: 100% !important;
      bottom: 0;
    }
  }
  .form-group {
    margin-bottom: 0 !important;
  }
  .selector-title {
    font-size: 20px;
    font-weight: 700;
    margin: 15px 0 5px 22px;
  }
  .selector-checkunit {
    margin-top: 13px;
    position: absolute;
    right: 80px;
  }
  .legenda-title {
    font-size: 20px;
    font-weight: 700;
    margin: 15px 0 -5px 22px;
  }
  .btn-close {
    margin: 20px 15px 0 -45px;
  }
  .btn-cross {
    width: 12px;
    height: auto;
  }
  .button-map img, .button-filter img, .button-legenda-map img {
    width: 85px;
    height: 66px;
    margin-left: 12px;
    border: 1px solid #E2DBD6;
    border-radius: 4px;
  }
  .button-map .active img, .button-filter .active img, .button-legenda-map .active img {
    border: 2px solid #00008c;
    box-shadow: 2px 3px 8px 1px rgba(27, 33, 58, 0.4);
  }

  .category-filter img{
    width: 75px;
    height: 75px;
  }

  .button-round img {
    width: 68px;
    height: 68px;
    margin-left: 12px;
    border: 1px solid #E2DBD6;
    border-radius: 34px;
  }
  .button-round .active img {
    border: 2px solid #00008c;
    box-shadow: 2px 3px 8px 1px rgba(27, 33, 58, 0.4);
  }
  .focus {
    box-shadow: none !important;
  }
  .btn-sm, .btn-group-sm > .btn {
    padding: 0 !important;
    border-radius: 0 !important;
    border: none;
    background-color: transparent;
  }
  .btn-outline-warning, .btn-outline-warning.focus {
    border: none !important;
    background-color: transparent !important;
    outline: none !important;
  }
  .btn-sm, .btn-group-sm > .btn p {
    font-family: 'Poppins', sans-serif;
    font-size: 10px !important;
    line-height: 16px !important;
    font-weight: 700 !important;
    color: #BEBEAF !important;
    padding: 5px 0 0 12px;
  }
  .btn-group-sm > .btn.active p {
    color: #000000 !important;
  }
  .btn-group.btn-group-sm {
    margin-top: 0 !important;
    display: table-cell;
  }
  img.mb-1 {
    margin-bottom: 0 !important;
  }
  .col-dots {
    width: 55px;
    margin-right: 5px;
    margin-top: 10px;
    display: table-cell;
  }

  .triangle-marker {
    margin-top:-14px !important;
  }

  .dots-legenda p {
    font-family: 'Poppins', sans-serif;
    font-size: 10px;
    line-height: 16px;
    font-weight: 700;
    color: #000000;
    margin: 0;
  }
  .timeseries-modal-container {
    margin: 10px;
  }
  .btn-modal-timeseries {
    color: #00008c;
    font-weight: 400;
    font-size: 14px;
    margin-top: 3px;
    background-color: white;
  }
  .custom-checkbox label {
    color: #00008c;
  }
  .alert-danger {
    margin: 0px !important;
    background-color: #ff2146 !important;
    z-index: 3000;
    border: 0px !important;
    border-radius: 0px !important;
  }

  .timedimension {
    padding-top: 15px;
    margin-right: 5px;
  }

  .leaflet-bar a {
    background-color:transparent !important;
  }
  .leaflet-bar a:hover {
    background-color:transparent !important;
  }
  .leaflet-control-locate {
    box-shadow: none !important;
    border: none !important;
  }

  @media screen and (max-width: 800px) {
    .dots-container {
      max-height: 162px;
    }
    .leaflet-popup-content {
      font-size: 8px;
    }
  }
  .compass-alert {
    display: none !important;
  }
  @media screen and (max-width: 800px) {
    .leaflet-bottom {
      position: fixed;
      bottom: 70px;
      z-index: 500;
    }
    .col-dots {
      margin-right: -5px;
    }
  }

  /* page Borden */
  @media screen and (min-width: 801px) {
    .v--modal-overlay[data-modal="bordenPopupChart"],
    .v--modal-overlay[data-modal="bordenPopupMap"] {
      background: rgba(0, 0, 140, 0.8) !important;
    }
    .borden-container .v--modal-box {
      left: calc(33vw - 300px) !important;
    }
    .borden-container .controllerModalLegends .v--modal {
      bottom: 37px !important;
    }
    .bordenPopupMap .controllerModalLegends .v--modal {
      bottom: calc(50vh - 300px) !important;
    }
    .bordenPopupMap .controllerModalSelector .v--modal {
      bottom: calc(50vh - 300px) !important;
    }
    .bordenPopupMap .modalLegends .v--modal-box {
      top: calc(50vh - 240px) !important;
    }
    .bordenPopupMap .timeseries-div-icon {
      pointer-events: none !important;
    }
    .bordenMap .leaflet-marker-icon {
      pointer-events: none !important;
    }
    #marker_hover_table {
      padding: 12px;
      font-size: 14px;
    }
    #marker_hover_table th {
      padding-right: 5px;
    }
  }
</style>


<style scoped>
  .btn-info {
    background-color: transparent !important;
    border: none !important;
    background-image: url(../../assets/images/map_legend.png);
    background-repeat: no-repeat;
    background-size: 54px 54px;
  }
  .btn-primary {
    background-color: transparent !important;
    border: none !important;
    background-image: url(../../assets/images/map_filter.png);
    background-repeat: no-repeat;
    background-size: 54px 54px;
    width: 54px;
    height: 54px;
  }

  .oppervlakte_water {
    display:none;
  }

  .oppervlakte_water.Shallow {
    display:block !important;
  }
</style>
